let CSATFeedback = function(fcModel: ng.resource.IResourceService) {
    return fcModel('/api/csatfeedback/:id/', { id: '@unique_token' }, {});
};

angular
    .module('fundersclub.support')
    .factory('CSATFeedback', CSATFeedback);
